<template>
  <div
    class="shadow"
    :class="{'border-top': active}"
  >
    <div class="help">
      <div class="help-on">
        <h2 class="name">MC-SILCS Sampling</h2>
        <v-row>
          The ligand conformation can be sampled and scored using the
          SILCS FragMap. The score is given as the overlap of ligand
          atom increases with respect to the given FragMaps.
        </v-row>
      </div>
    </div>
    <div class="navigation">
      <template v-if="active">
        <i
          class="el-icon-circle-close close"
          @click="toggle"
        />
      </template>
      <template v-else>
        <v-row
          class="open"
          @click="toggle"
        >
          <i class="el-icon-information" />
          Help
        </v-row>
      </template>
    </div>
  </div>
</template>

<script>
  // import Marked from 'marked'
  // let renderer = new Marked.Renderer()

  // Marked.setOptions({
  //   renderer: renderer,
  //   sanitize: true
  // })

  export default {
    name: 'Mcligandhelp',
    data () {
      return {
        active: true,
      }
    },
    computed: {
    },
    methods: {
      toggle: function () {
        this.active = !this.active
      },
    },
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
